{
  "formatVersion": 1,
  "machines": [
    {
      "id": "dune-circuit",
      "version": "2.0.6",
      "title": "DUNE CIRCUIT",
      "subtitle": "Link the checkpoints. Own the midnight coast.",
      "era": "dmd-1990s",
      "difficulty": 3,
      "balls": 3,
      "definitionHash": "f16138ffb82823009a045660d4ac574f6f8ae28333f03555cccf95145d3bc7dd",
      "rulesheet": [
        "Dune Ramp then Coast Loop within 8 seconds earns a checkpoint.",
        "Three checkpoints light Pit Stop for Race Multiball.",
        "Multiball: Dune Ramp first. Alternate Ridge and Dune for jackpots."
      ],
      "illustration": {
        "asset": "d3-cabinet-original",
        "tile": 0
      }
    },
    {
      "id": "iron-fathom",
      "version": "1.2.9",
      "title": "IRON FATHOM",
      "subtitle": "Take the light down. Bring the crew back.",
      "era": "ss-1980s",
      "difficulty": 2,
      "balls": 5,
      "definitionHash": "81a9cd435ac68eb056b8da4ad668ff242fcd32a3a8c4a7138ed01330fcf382b6",
      "rulesheet": [
        "Complete R-I-G and shoot the hatch to begin a dive.",
        "Build depth with shots, then bank it at the hatch.",
        "Complete four dives and bank 25 depth. Shoot the hatch for Surface."
      ]
    },
    {
      "id": "neon-nova",
      "version": "1.7.11",
      "title": "NEON NOVA",
      "subtitle": "Collapse the star. Survive the light.",
      "era": "dmd-1990s",
      "difficulty": 4,
      "balls": 3,
      "definitionHash": "0a538b562476ab988f23d447bfd9b9239abdf887ce0aff4d01a9abf6596f6e16",
      "rulesheet": [
        "Charge the Star Core and shoot the scoop to start Star Systems.",
        "Lock balls in the Wormhole to start Nova Multiball.",
        "Complete six systems and start Nova Multiball. Shoot Event Horizon for Supernova."
      ]
    },
    {
      "id": "pier-carnival",
      "version": "2.0.7",
      "title": "PIER CARNIVAL",
      "subtitle": "Win the tickets. Light up the pier.",
      "era": "dmd-1990s",
      "difficulty": 2,
      "balls": 3,
      "definitionHash": "b9489487c60b77572b4b75059477530a7dbbad0f63fc04fbc306ce886a06cdb3",
      "rulesheet": [
        "Complete both target banks for four tickets and higher bonus.",
        "Collect 12 tickets. Prize Booth starts Prize Multiball.",
        "In multiball, Spinner adds tickets. Prize Booth pays jackpots."
      ],
      "illustration": {
        "asset": "d3-cabinet-original",
        "tile": 2
      }
    },
    {
      "id": "starfall-salvage",
      "version": "1.0.1",
      "title": "STARFALL SALVAGE",
      "subtitle": "Take the contract. Bring the crew home.",
      "era": "lcd-modern",
      "difficulty": 3,
      "balls": 3,
      "definitionHash": "bf65b3fdfe054b5ee439bec802564dcdda090d7aa61b0991397a9aefa19e9c9d",
      "rulesheet": [
        "Hit Contract Board. Cargo Bay accepts the selected job. Launch Rail refuels.",
        "Complete jobs to earn ranks. Three jobs on one ball qualify Leviathan Approach.",
        "Open Hull, lock two balls, then Cargo Bay for multiball. Admiral + Approach light Leviathan."
      ],
      "illustration": {
        "asset": "starfall-original",
        "tile": 3
      }
    },
    {
      "id": "surf-rescue",
      "version": "2.0.8",
      "title": "SURF RESCUE",
      "subtitle": "Read the beacon. Bring everyone ashore.",
      "era": "ss-1980s",
      "difficulty": 2,
      "balls": 5,
      "definitionHash": "6721d416e4667c4979356f451d3d7896f5f7776d9458e24fd204fff624e94b54",
      "rulesheet": [
        "Complete the crew targets. Lifeboat starts a rescue.",
        "In 40 seconds, hit Rescue Bridge and both loops.",
        "Three rescues light Lifeboat for Boat Launch Multiball."
      ],
      "illustration": {
        "asset": "d3-cabinet-original",
        "tile": 1
      }
    }
  ],
  "bays": [
    "neon-nova",
    "starfall-salvage",
    "iron-fathom",
    "pier-carnival",
    "surf-rescue",
    "dune-circuit"
  ]
}
